import { createFileRoute } from "@tanstack/react-router";

import { Integrations } from "@/features/settings/integrations/integrations";

export const Route = createFileRoute("/_authenticated/settings/integrations")({
  component: Integrations,
});
